import App from 'components/app/App';
import 'core-js/stable';
import GlobalStyle from 'index.styles';
import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import 'regenerator-runtime/runtime';
import 'url-polyfill';

import { AppProvider } from './services/AppContext';
import { AppTextProvider } from './services/AppTextContext';
import { LicenseNoteContextProvider } from './services/LicenseNoteContext';
import * as serviceWorker from './serviceWorker';
import { SaferPayScriptContextProvider } from './services/SaferPayScriptContext';
import { GooglePayConfigurationContextProvider } from './services/GooglePayConfigurationContext';
import { ApplePayConfigurationContextProvider } from './services/ApplePayConfigurationContext';
import { CardProvider } from './services/CardContext';
import { SelectedMethodContextProvider } from './services/SelectedMethodContext';
import './Sentry';
import { AppStateContextProvider } from './services/AppStateContext';

const root = document.getElementById('root');

function AppContainer() {
  return (
    <>
      <AppProvider>
        <AppTextProvider>
          <LicenseNoteContextProvider>
            <SaferPayScriptContextProvider>
              <GooglePayConfigurationContextProvider>
                <ApplePayConfigurationContextProvider>
                  <CardProvider>
                    <SelectedMethodContextProvider>
                      <AppStateContextProvider>
                        <App />
                      </AppStateContextProvider>
                    </SelectedMethodContextProvider>
                  </CardProvider>
                </ApplePayConfigurationContextProvider>
              </GooglePayConfigurationContextProvider>
            </SaferPayScriptContextProvider>
          </LicenseNoteContextProvider>
        </AppTextProvider>
      </AppProvider>
      <GlobalStyle />
    </>
  );
}

ReactDOM.render(<AppContainer />, root);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
